import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';

import { Switch, Route } from 'react-router-dom';

import { SideMenuWithTOC, TOC, WhitePanel } from '../../components';

import Bnb from './Bnb';
import Press from './Press';
import Guide from './Guide';
import Bloggers from './Bloggers';
import LodgeOwner from './LodgeOwner';
import TravelAgent from './TravelAgent';
import NonResNepali from './NonResNepali';
import DestinationPromotion from './DestinationPromotion';

const titles = [
  'Lodge Owners',
  'Guides',
  'Travel Agents',
  'Non Residential Nepali',
  'Bloggers',
  'Bed and Breakfasts',
  'Destination Promotion Organization',
  'Press Center',
];

const partnersRoutes = [
  { path: '/partners/lodge-owners', component: LodgeOwner },
  { path: '/partners/guides', component: Guide },
  { path: '/partners/travel-agents', component: TravelAgent },
  { path: '/partners/non-residential-nepali', component: NonResNepali },
  { path: '/partners/bloggers', component: Bloggers },
  { path: '/partners/bed-and-breakfasts', component: Bnb },
  { path: '/partners/destination-promotion-organization', component: DestinationPromotion },
  { path: '/partners/press-center', component: Press },
  { path: '/', component: LodgeOwner },
];

const PartnersHome = () => (
  <Container>
    <Row>
      <Col className="state-page">
        <WhitePanel>
          <Row>
            <Col lg="3" md="3" className="d-none d-md-block">
              <TOC titles={titles} urlPrefix="/partners" />
            </Col>
            <Col lg="9" md="9" className="region-content">
              <SideMenuWithTOC titles={titles} forMobile urlPrefix="/partners" />
              <Switch>
                <Fragment>
                  <h1>PARTNER WITH HONEYGUIDE</h1>
                  {partnersRoutes.map(r => (
                    <Route key={r.path} exact path={r.path} component={r.component} />
                  ))}
                </Fragment>
              </Switch>
            </Col>
          </Row>
        </WhitePanel>
      </Col>
    </Row>
  </Container>
);

export default PartnersHome;



// WEBPACK FOOTER //
// ./src/screens/Partners/PartnersHome.jsx